import { useTranslation } from 'react-i18next'
import { Button } from '@/components/button'

const PageButtons = ({ urls = [], index, selectPage, previousDocument, nextDocument, isEdit }) => {
  const { t } = useTranslation()
  const isFirstPage = index === 0
  const isLastPage = urls?.length === index + 1
  const backDisabled = index === 0 && (!previousDocument || isEdit)
  const nextDisabled = isLastPage && (!nextDocument || isEdit)

  const handleBack = () => {
    selectPage('right')
  }

  const handleNext = () => {
    selectPage('left')
  }
  const backText = isFirstPage
    ? t('common.previous_document', 'Previous Document')
    : t('common.previous_page', 'Previous Page')

  const nextText = isLastPage
    ? t('common.next_document', 'Next Document')
    : t('common.next_page', 'Next Page')
  return (
    <>
      <Button theme="secondary" onClick={handleBack} disabled={backDisabled}>
        &#60; {backText}
      </Button>
      <Button theme="secondary" onClick={handleNext} disabled={nextDisabled}>
        {nextText} &#62;
      </Button>
    </>
  )
}

export default PageButtons
